import './ButtonsContainer.css'

type ButtonsContainerProps = {
  title?: string,
  children?: React.ReactNode
}

export default function ButtonsContainer(props: ButtonsContainerProps) {

  return (
    <div className='buttons-container'>
      <p style={{marginBlockEnd: 0, marginBlockStart: 0, fontSize:"48px", fontWeight: 600}}>{props.title}</p>
      <div style={{display:"flex", flexDirection:"column", justifyContent:"space-between", gap: "16px", height: "100%"}}>
        {props.children}
      </div>
    </div>
  )
}